<ion-grid class="grid-clima">
  <ion-row>
    <ion-col size="3">
      <div class="col-card">
        <p class="titulo"> TEMPERATURA </p>
        <ion-icon name="termometro"></ion-icon>
        <p class="valor">{{estacao?.temperatura || '--'}}</p>
        <p class="unidade-medida"> °C </p>
      </div>
    </ion-col>

    <ion-col size="3">
      <div class="col-card">
        <p class="titulo"> VENTO </p>
        <ion-icon name="vento-clima"></ion-icon>
        <p class="valor"> {{estacao?.vento || '--'}} </p>
        <p class="unidade-medida"> km/h </p>
      </div>
    </ion-col>

    <ion-col size="3">
      <div class="col-card">
        <p class="titulo"> CHUVA </p>
        <ion-icon name="nuvem"></ion-icon>
        <p class="valor"> {{estacao?.chuva || '--'}} </p>
        <p class="unidade-medida"> mm </p>
      </div>
    </ion-col>

    <ion-col size="3">
      <div class="col-card">
        <p class="titulo"> UMIDADE </p>
        <ion-icon name="gota"></ion-icon>
        <p class="valor"> {{estacao?.umidade || '--'}} </p>
        <p class="unidade-medida"> % </p>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
